// import { publicPath } from '../config';
//
// const audio = Symbol('audio');
// const sources = Symbol('sources');

import { publicPath } from '../config';
import { ObjectStrings } from '../types/commonTypes';

const audio = new Audio();
audio.volume = 1;

const sources: ObjectStrings = {
  message: `${publicPath}audio/new-message.mp3`,
};

export const playSound = (type = 'message') => {
  try {
    const source = sources[type];
    if (!source) return;

    audio.src = source;
    audio.play();
  } catch (e) {
    console.log(e);
  }
};
